<mat-dialog-content>
  <p style="font-size: 1.5rem">Are you sure you want to delete this form?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="back-button" mat-dialog-close="cancel">Back</button>
  <button class="delete-button" mat-dialog-close="delete">Delete</button>
</mat-dialog-actions>
